import { useBankIDSessionsQuery } from 'hooks/webapi';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { BANK_ID_CONFIRM } from 'Router/routes';
import { handleErrorRedirect } from '../BankIdInfo/useBankIdInfo';

export default function useBankIDWaiting() {
  const navigate = useNavigate();

  const bankIdSessionId = localStorage.getItem('bankIdSessionId');
  const {
    data: bankIdSessionData,
    isFetching,
    refetch: refetchBankIdSession,
  } = useBankIDSessionsQuery(
    { uuid: bankIdSessionId! },
    Boolean(bankIdSessionId),
    5000,
  );

  useEffect(() => {
    if (
      !bankIdSessionId ||
      !bankIdSessionData?.sessionStatus ||
      bankIdSessionData.sessionStatus === 'ACCESS_TOKEN_RECEIVED'
    ) {
      refetchBankIdSession();
      return;
    }

    if (bankIdSessionData?.sessionStatus === 'SUCCESS') {
      navigate(BANK_ID_CONFIRM);
      return;
    }

    handleErrorRedirect(navigate, bankIdSessionData?.sessionStatus, true);
  }, [bankIdSessionData?.sessionStatus, bankIdSessionId, navigate]);

  return { isLoading: isFetching };
}
